module.exports = __webpack_public_path__ + "img/crystal_23_b.da62bf99.jpg";